import { render, staticRenderFns } from "./PortalServicios.vue?vue&type=template&id=e3e28b42&scoped=true"
import script from "./PortalServicios.vue?vue&type=script&lang=ts"
export * from "./PortalServicios.vue?vue&type=script&lang=ts"
import style0 from "./PortalServicios.vue?vue&type=style&index=0&id=e3e28b42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3e28b42",
  null
  
)

export default component.exports